







































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import user from '@/store/modules/user';
import CompanyMixin from '@/mixins/CompanyMixin';
import TweenLite from 'gsap/TweenMax';
import {Chart} from 'highcharts-vue';
import ProfitLoss from '@/charts/ProfitLoss.vue';
import DynamicLineChart from '@/charts/DynamicLineChart.vue';
import DynamicColumnChart from '@/charts/DynamicColumnChart.vue';
import BalanceGT from '@/charts/BalanceGT.vue';

@Component({components: {Chart, ProfitLoss, DynamicLineChart, DynamicColumnChart, BalanceGT}})
export default class Quick extends CompanyMixin {
  instructionsClosed() {
    this.focusFirst();
  }

  openFullscreen() {
    const elem: any = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE/Edge */
      elem.msRequestFullscreen();
    }
  }

  closeFullscreen() {
    const elem: any = document;
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (elem.mozCancelFullScreen) {
      /* Firefox */
      elem.mozCancelFullScreen();
    } else if (elem.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      elem.webkitExitFullscreen();
    } else if (elem.msExitFullscreen) {
      /* IE/Edge */
      elem.msExitFullscreen();
    }
  }

  close() {
    this.closeFullscreen();
  }

  thisVersion() {
    if (process.env.VUE_APP_BRAND === 'GT') {
      return 'gt';
    }
  }

  setAspectratio() {
      const screenwidth = screen.width;
      const screenheight = screen.height;
      const aspectratio = screenwidth / screenheight;
      const setRemsize = document.getElementsByTagName('html')[0];

      const p = document.getElementById('presentation');
      if (!p) {
        return;
      }

      if (aspectratio > 16 / 9) {
          p.style.height = '100%';
          p.style.width = 'calc(100vh / 9 * 16)';
          setRemsize.style.fontSize = 'calc((100vh / 1080) * 18)';
      } else {
          p.style.width = '100%';
          p.style.height = 'calc(100vw / 16 * 9)';
          setRemsize.style.fontSize = 'calc((100vw / 1920) * 18)';
      }
  }

  focusFirst() {
    // const startelement = document.getElementById('first-slide');
    if (this.$refs.start) {
      (this.$refs.start as any).focus();
    }
  }

  setDataAttribute() {
    const dataItemContainer = document.getElementsByClassName('item-container');
    for (let i = 0; i < dataItemContainer.length; i++) {
      (dataItemContainer[i] as any).dataset.itemContainer = '' + i + '';
    }

    for (let i = 0; i < dataItemContainer.length; i++) {
      const dataItems = document.querySelectorAll('[data-item-container="' + i + '"] > .item');
      for (let j = 0; j < dataItems.length; j++) {
        (dataItems[j] as any).dataset.itemContainer = '' + i + '';
        (dataItems[j] as any).dataset.item = '' + j + '';
      }
    }

    const dataContentContainer = document.getElementsByClassName('content-container');
    for (let i = 0; i < dataContentContainer.length; i++) {
      (dataContentContainer[i] as any).dataset.contentContainer = '' + i + '';
    }

    for (let i = 0; i < dataContentContainer.length; i++) {
      const dataContent = document.querySelectorAll('[data-content-container="' + i + '"] > .content-box');
      for (let j = 0; j < dataContent.length; j++) {
        (dataContent[j] as any).dataset.contentContainer = '' + i + '';
        (dataContent[j] as any).dataset.contentBox = '' + j + '';
      }
    }

    for (let i = 0; i < dataContentContainer.length; i++) {
      const dataListItemDynamic = document.querySelectorAll('[data-content-container="' + i + '"] .list-item-dynamic');
      for (let j = 0; j < dataListItemDynamic.length; j++) {
        (dataListItemDynamic[j] as any).dataset.contentContainer = '' + i + '';
        (dataListItemDynamic[j] as any).dataset.listItemDynamic = '' + j + '';
      }
    }

    for (let i = 0; i < dataContentContainer.length; i++) {
      const dataSubContent = document.querySelectorAll('[data-content-container="' + i + '"] .sub-content-box');
      for (let j = 0; j < dataSubContent.length; j++) {
        (dataSubContent[j] as any).dataset.contentContainer = '' + i + '';
        (dataSubContent[j] as any).dataset.listItemDynamic = '' + j + '';
      }
    }
  }

  setSlide() {
    if (!event) {
      return;
    }
    const clicked = event.target;
    const clickedItemContainer = (clicked as any).dataset.itemContainer;
    const clickedItem = (clicked as any).dataset.item;

    const items = document.getElementsByClassName('item');
    const slides = document.getElementsByClassName('content-box');
    const subSlides = document.getElementsByClassName('sub-content-box');

    for (let i = 0; i < slides.length; i++) {
      if ((slides[i] as any).dataset.contentContainer === clickedItemContainer) {
        slides[i].classList.remove('content-active');
        items[i].classList.remove('item-active');
      }
    }

    for (let i = 0; i < subSlides.length; i++) {
      if ((slides[i] as any).dataset.contentContainer === clickedItemContainer) {
        subSlides[i].classList.remove('content-active');
      }
    }

    for (let i = 0; i < slides.length; i++) {
      // tslint:disable-next-line:max-line-length
      if ((slides[i] as any).dataset.contentContainer === clickedItemContainer && (slides[i] as any).dataset.contentBox === clickedItem) {
        slides[i].classList.toggle('content-active');
        items[i].classList.toggle('item-active');
      }
    }
  }

  setSubSlide() {
    if (!event) {
      return;
    }

    const clicked = event.target;
    const clickedContentContainer = (clicked as any).dataset.contentContainer;
    const clickedListItemDynamic = (clicked as any).dataset.listItemDynamic;

    const dynamicItems = document.getElementsByClassName('list-item-dynamic');
    const slides = document.querySelectorAll('.content-box,.sub-content-box');
    const subSlides = document.getElementsByClassName('sub-content-box');
    // console.log(slides);


    for (const slide of slides) {
      if ((slide as any).dataset.contentContainer === clickedContentContainer) {
        slide.classList.remove('content-active');
      }
    }

    for (const slide of slides) {
      // tslint:disable-next-line:max-line-length
      if ((slide as any).dataset.contentContainer === clickedContentContainer && (slide as any).dataset.listItemDynamic === clickedListItemDynamic) {
        slide.classList.toggle('content-active');
      }
    }
  }

  mounted() {
    this.setAspectratio();
    this.focusFirst();
    this.setDataAttribute();
  }
}
